import React from 'react';
import { Row, Col, Form, Button } from 'react-bootstrap';
import { FaSearch, FaFileExcel } from 'react-icons/fa';
import Select from 'react-select';
import { customStyles, DropdownIndicator } from '~/Styles/reactSelectStyles';

// W-0607 — filtros da consulta (GE + dia/mês ini/fim + vendedor).
// Componente presentacional: state vive no Formik da página (TechSpec §3.5).

const Filtros = ({
  formik,
  opcoesGrupoEmpresa,
  opcoesVendedor,
  carregandoVendedores,
  onBuscar,
  onExportar,
  podeExportar,
  buscando,
}) => {
  const { values, errors, touched, setFieldValue, handleBlur } = formik;

  const grupoSelecionado =
    opcoesGrupoEmpresa.find(o => o.value === values.codigoGrupoEmpresa) || null;
  const vendedorSelecionado =
    opcoesVendedor.find(o => o.value === values.codigoVendedor) || null;

  const erroCampo = campo =>
    touched[campo] && errors[campo] ? (
      <div style={{ color: '#d63232', fontSize: '12px', marginTop: '2px' }}>
        {errors[campo]}
      </div>
    ) : null;

  const handleKeyDown = e => {
    if (e.key === 'Enter') onBuscar();
  };

  return (
    <Row className="align-items-end">
      <Col xs={12} md={3}>
        <Form.Group>
          <Form.Label>Grupo Empresa</Form.Label>
          <Select
            options={opcoesGrupoEmpresa}
            value={grupoSelecionado}
            onChange={opt =>
              setFieldValue('codigoGrupoEmpresa', opt ? opt.value : null)
            }
            styles={customStyles}
            components={{ DropdownIndicator }}
            placeholder="Selecione..."
            isClearable={false}
            noOptionsMessage={() => 'Nenhum grupo disponível'}
          />
          {erroCampo('codigoGrupoEmpresa')}
        </Form.Group>
      </Col>

      <Col xs={6} md={1}>
        <Form.Group>
          <Form.Label>Dia Ini.</Form.Label>
          <Form.Control
            type="number"
            min="1"
            max="31"
            name="diaIni"
            value={values.diaIni}
            onChange={e => setFieldValue('diaIni', e.target.value)}
            onBlur={handleBlur}
            onKeyDown={handleKeyDown}
          />
          {erroCampo('diaIni')}
        </Form.Group>
      </Col>

      <Col xs={6} md={1}>
        <Form.Group>
          <Form.Label>Mês Ini.</Form.Label>
          <Form.Control
            type="number"
            min="1"
            max="12"
            name="mesIni"
            value={values.mesIni}
            onChange={e => setFieldValue('mesIni', e.target.value)}
            onBlur={handleBlur}
            onKeyDown={handleKeyDown}
          />
          {erroCampo('mesIni')}
        </Form.Group>
      </Col>

      <Col xs={6} md={1}>
        <Form.Group>
          <Form.Label>Dia Fim</Form.Label>
          <Form.Control
            type="number"
            min="1"
            max="31"
            name="diaFim"
            value={values.diaFim}
            onChange={e => setFieldValue('diaFim', e.target.value)}
            onBlur={handleBlur}
            onKeyDown={handleKeyDown}
          />
          {erroCampo('diaFim')}
        </Form.Group>
      </Col>

      <Col xs={6} md={1}>
        <Form.Group>
          <Form.Label>Mês Fim</Form.Label>
          <Form.Control
            type="number"
            min="1"
            max="12"
            name="mesFim"
            value={values.mesFim}
            onChange={e => setFieldValue('mesFim', e.target.value)}
            onBlur={handleBlur}
            onKeyDown={handleKeyDown}
          />
          {erroCampo('mesFim')}
        </Form.Group>
      </Col>

      <Col xs={12} md={3}>
        <Form.Group>
          <Form.Label>Vendedor</Form.Label>
          <Select
            options={opcoesVendedor}
            value={vendedorSelecionado}
            onChange={opt =>
              setFieldValue('codigoVendedor', opt ? opt.value : null)
            }
            styles={customStyles}
            components={{ DropdownIndicator }}
            placeholder={
              values.codigoGrupoEmpresa
                ? 'Todos os vendedores'
                : 'Selecione o grupo primeiro'
            }
            isClearable
            isDisabled={!values.codigoGrupoEmpresa}
            isLoading={carregandoVendedores}
            noOptionsMessage={() => 'Nenhum vendedor'}
          />
        </Form.Group>
      </Col>

      <Col xs={12} md="auto">
        <Form.Group>
          <Form.Label className="d-none d-md-block">&nbsp;</Form.Label>
          <div>
            <Button
              variant="primary"
              onClick={onBuscar}
              className="mr-2"
              disabled={buscando}
            >
              <FaSearch className="mr-1" /> Filtrar
            </Button>
            <Button
              variant="success"
              onClick={onExportar}
              disabled={!podeExportar}
            >
              <FaFileExcel className="mr-1" /> Exportar Excel
            </Button>
          </div>
        </Form.Group>
      </Col>
    </Row>
  );
};

export default Filtros;
